import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Call Settings'
      breadcrumbs={[
        {
          label: 'Phone',
        },
        {
          label: 'Call Settings',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/phone/call-settings',
  component: RouteComponent,
  type: 'auth',
  locationRequired: true,
});
